import { forwardRef, JSX, useEffect } from 'react';

import { CloseIcon } from '~components/icons/CloseIcon';
import { ConfirmDeleteController } from '~modules/media-library/controller/ConfirmDeleteController';
import { AssetId } from '~modules/media-library/model/Asset';
import { Button } from '~modules/media-library/view/Button';

type ConfirmDeleteModalPanelProps = {
  onClose?: () => void;
  onDeleteSuccess?: () => void;
  assetId: AssetId;
};

export const ConfirmDeleteModalPanel = forwardRef<
  HTMLDivElement,
  JSX.IntrinsicElements['div'] & ConfirmDeleteModalPanelProps
>(function ConfirmDeleteModal({ onClose, onDeleteSuccess, className, assetId, ...TheirProps }, ref) {
  const hasAssetId = Boolean(assetId);

  useEffect(() => {
    if (!hasAssetId) {
      onClose?.();
    }
  }, [hasAssetId, onClose]);

  if (!hasAssetId) return null;

  return (
    <div
      className={`ml--detail-modal--panel bg-white overflow-y-auto rounded-md shadow-xl w-full max-w-lg max-h-lg min-h-0 max-h-full flex flex-col relative ${
        className ? className : ''
      }`}
      {...TheirProps}
      ref={ref}
    >
      <Button variant="icon" className="absolute top-0 right-0 border-none" onClick={onClose}>
        <CloseIcon />
      </Button>
      <ConfirmDeleteController assetId={assetId} onClose={onClose} onDeleteSuccess={onDeleteSuccess} />
    </div>
  );
});
